import styled from 'styled-components';
import { Modal } from 'react-bootstrap';

export const StyledModal = styled(Modal)`
  max-width: 95% !important;
  width: 95% !important;
`;

export const Section = styled.div`
  padding: 1rem;
`;

export const SmAttemptsSection = styled.div`
  margin-bottom: 1rem;
`;

export const SmListBox = styled.div`
  max-height: 220px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 6px;
  padding: 8px;
  margin-top: 8px;
  background-color: #fff;
`;

export const SmListItem = styled.div`
  padding: 0.75rem;
  border-bottom: 1px solid #dee2e6;
  cursor: pointer;
  font-family: inherit;
  font-size: 0.95rem;
  color: #343a40;

  &.selected {
    background-color: #eaf6ff;
  }

  .sm-status-inline {
    display: flex;
    align-items: center;
  }

  .sm-status-title {
    display: inline-block;
    font-weight: 600;
    font-size: 0.95rem;
    margin: 0;
    margin-right: 8px;
  }

  &.status-success .sm-status-title {
    color: #28a745;
  }

  &.status-warning .sm-status-title {
    color: #ffc107;
  }

  &.status-error .sm-status-title {
    color: #dc3545;
  }

  &.status-default .sm-status-title {
    color: #6c757d;
  }

  .sm-status-text {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .log-content {
    font-family: inherit;
    font-size: 0.95rem;
    color: #343a40;
  }
`;

export const SmEventsSection = styled.section`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
`;

export const SmEventsBox = styled.div`
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 0.75rem;
  background: #fff;

  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const JsonBox = styled.div`
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  padding: 1rem;
  max-height: 240px;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;

  font-family: inherit; /* Corrige monoespaçada */
  font-size: 0.95rem;
  color: #343a40;

  pre {
    font-family: inherit; /* Garante que o <pre> siga o mesmo estilo */
    font-size: inherit;
    color: inherit;
    margin: 0;
  }
`;

export const LogEntry = styled.div`
cursor: default;
  .status {
    margin-right: 0.5rem;
    
  font-size: 0.9rem;
  margin-bottom: 0.4rem;

  &.sucesso {
    color: #28a745;
  }

  &.falha {
    color: #fd7e14;
  }

  &.cancelada {
    color: #dc3545;
  }
`;

export const ApiSection = styled.div`
  margin-top: 1.5rem;

  textarea {
    width: 100%;
    border: 1px solid #ccc;
    border-radius: 6px;
    padding: 0.5rem;
    font-family: inherit;
    font-size: 0.95rem;
    color: #343a40;
  }
`;

export const ConfirmationWrapper = styled.div`
  overflow-x: auto;
  padding-bottom: 1rem;
`;

export const ConfirmationGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, minmax(220px, 1fr));
  grid-gap: 1.5rem;
  min-width: 900px;
`;

export const FieldWrapper = styled.div`
  margin-bottom: 1.5rem;

  .label {
    text-transform: uppercase;
    font-size: 0.75rem;
    color: #6c757d;
    margin-bottom: 0.25rem;
    display: block;
    border-bottom: 1px solid #e0e0e0;
    padding-bottom: 4px;
    margin-bottom: 6px;
  }

  .value {
    font-size: 1rem;
    color: #343a40;
    line-height: 1.4;
  }
`;

export const Badge = styled.span`
  display: inline-flex;
  justify-content: center;
  padding: 0.4rem 0.8rem;
  font-size: 0.85rem;
  font-weight: 600;
  border-radius: 0.25rem;
  margin-top: 0.25rem;

  &.badge-orange {
    color: #856404;
    background-color: #fff3cd;
  }

  &.badge-green {
    color: #155724;
    background-color: #d4edda;
  }

  &.badge-blue {
    color: #004085;
    background-color: #cce5ff;
  }

  &.badge-default {
    color: #383d41;
    background-color: #e2e3e5;
  }
`;
